/** @format */

export enum Department {
    NEW = 'New',
    USED = 'Used',
}

export enum TaxonomyTermType {
    CATEGORY = 'Category',
    CAROUSEL = 'Carousel',
    BRAND = 'Brand',
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface Descriptor {
    department: Department;
    language: string;
    name: string | null;
    title: string;
    urlSegment: string;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface TaxonomyTermPage {
    department?: Department;
    language: string;
    marketUrlSlug?: string;
    name: string | null;
    slug?: string;
    title: string;
    url: string;
}

// Touch and Change
// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export interface TaxonomyTerm {
    categoryPage: TaxonomyTermPage[];
    descriptors: Descriptor[];
    children: TaxonomyTerm[];
    id: number | null;
    name: string;
    parentCategory?: string | null;
    popularity?: number;
    sorting?: number;
    type: TaxonomyTermType;
    slug?: string;
    uid?: number;
}

export type Taxonomy = TaxonomyTerm;
